function tryParse(str) {
  try { return JSON.parse(str); } catch { return null; }
}
function unwrap(data) {
  let p = data;
  if (typeof p === "string") {
    const v = tryParse(p);
    if (v == null) return null;
    p = v;
  }
  if (p && typeof p.data === "string") {
    const inner = tryParse(p.data);
    if (inner && typeof inner === "object") p = inner;
  }
  return p;
}

export function reconstructActiveIds(historyItems, classify) {
  const items = Array.isArray(historyItems) ? historyItems : [];
  const sorted = [...items].sort((a, b) => {
    const ta = typeof a?.timestamp === "number" ? a.timestamp : 0;
    const tb = typeof b?.timestamp === "number" ? b.timestamp : 0;
    return tb - ta; 
  });

  const decided = new Map();

  for (const entry of sorted) {
    const op = classify(entry?.data, entry?.name);
    if (!op) continue;

    if (op.type === "upsert" && !decided.has(op.id)) decided.set(op.id, true);
    else if (op.type === "remove" && !decided.has(op.id)) decided.set(op.id, false);
    else if (op.type === "replace") {
      for (const id of op.ids) if (!decided.has(id)) decided.set(id, true);
      break;
    }
  }

  const active = new Set();
  for (const [id, on] of decided) if (on) active.add(id);
  return active;
}

export function classifyQnaMessage(data) {
  const p = unwrap(data);
  if (p == null) return null;

  if (Array.isArray(p)) {
    const ids = p
      .filter((q) => q && typeof q === "object" && q.isApproved === true && q.id != null)
      .map((q) => String(q.id));
    return ids.length ? { type: "replace", ids } : null;
  }
  if (!p || typeof p !== "object") return null;

  if (typeof p.removeQuestionId === "string" || typeof p.removeQuestionId === "number") {
    return { type: "remove", id: String(p.removeQuestionId) };
  }
  if (p.question && typeof p.question === "object" && p.question.id != null) {
    return { type: "upsert", id: String(p.question.id) };
  }

  if (Array.isArray(p.data)) {
    if (p.data.length === 1) {
      const item = p.data[0];
      if (item && typeof item === "object" && item.id != null) {
        return item.isApproved === true ? { type: "upsert", id: String(item.id) } : { type: "remove", id: String(item.id) };
      }
    }
    if (p.data.length === 0) return { type: "replace", ids: [] };
    const approved = p.data
      .filter((q) => q && typeof q === "object" && q.isApproved === true && q.id != null)
      .map((q) => String(q.id));
    return { type: "replace", ids: approved };
  }

  return null;
}

export function classifyPollMessage(data, name) {
  if (name === "poll-active" || name === "poll-inactive") {
    const p = unwrap(data);
    if (name === "poll-active") {
      const item = Array.isArray(p?.data) ? p.data[0] : null;
      const id = item?.id;
      return id != null ? { type: "upsert", id: String(id) } : null;
    }
    const id = p?.id;
    return id != null ? { type: "remove", id: String(id) } : null;
  }

  const p = unwrap(data);
  if (p == null || typeof p !== "object") return null;

  if (Array.isArray(p)) {
    const ids = p
      .filter((q) => q && typeof q === "object" && q.isApproved === true && q.id != null)
      .map((q) => String(q.id));
    return ids.length ? { type: "replace", ids } : null;
  }

  if (p.poll && typeof p.poll === "object") {
    const pid = p.poll.id;
    return pid != null ? { type: "upsert", id: String(pid) } : null;
  }
  if (Array.isArray(p.polls)) {
    const ids = p.polls.filter((q) => q && typeof q === "object" && q.isApproved === true && q.id != null).map((q) => String(q.id));
    return { type: "replace", ids };
  }

  if (p.clear === true || p.type === "clear" || p.action === "clear") {
    if (p.clearCategory === "poll-survey") return null;
    return { type: "replace", ids: [] };
  }
  if (Array.isArray(p.data)) {
    if (p.data.length === 0 && p.clearCategory !== "poll-survey") return { type: "replace", ids: [] };
    if (p.data.length === 0) return null;
    if (p.data.length === 1) {
      const item = p.data[0];
      if (item && typeof item === "object" && item.id != null) {
        return item.isApproved === true ? { type: "upsert", id: String(item.id) } : { type: "remove", id: String(item.id) };
      }
    }
    const approved = p.data.filter((q) => q && typeof q === "object" && q.isApproved === true && q.id != null).map((q) => String(q.id)).filter((v) => v !== "undefined" && v !== "null");
    return { type: "replace", ids: approved };
  }

  return null;
}
